export default __webpack_public_path__ + "static/media/36.6e1339be.mp3";